import { z } from "zod";

export const ObservationCategoryOutputSchema = z.object({
	id: z.number(),
	uuid: z.string().uuid(),
	name: z.string(),
	createdAt: z.string().datetime(),
	updatedAt: z.string().datetime(),
	publishedFormsCount: z.number(),
	draftFormsCount: z.number()
});

export const ObservationCategoriesSchema = z.array(
	ObservationCategoryOutputSchema
);

export type ObservationCategoryModel = z.infer<
	typeof ObservationCategoryOutputSchema
>;
